<template>
  <div>
    <!--<van-nav-bar :title="titles"
                 :fixed="true"
                 @click-left="backUp"
                 @click-right="backMain">
                 @click-right="handleClick"
      <template #left>
        <<van-icon name="https://b.yzcdn.cn/vant/icon-demo-1126.png" size="18"></van-icon>
        <van-icon name="https://b.yzcdn.cn/vant/icon-demo-1126.png" size="18"  v-if="!isNeedBackShow"></van-icon>
        <span v-else-if="isNeedBackShow">返回</span>
      </template>
      <template #right>
        <van-icon name="https://b.yzcdn.cn/vant/icon-demo-1126.png" size="18"  v-if="isNeedBackShow"></van-icon>
      </template>
    </van-nav-bar> -->
     <!--<Sidebar :sidebarShow="sidebarShow" v-on:hideSidebar="setSidebar" ></Sidebar>
    <div style="margin-top:44px;">-->
      <div>
      <router-view @titleChange="setTitleContent" ref="OrderCondition"></router-view>
      <!-- <div style="height: 5rem;"></div> -->
      <van-tabbar  route v-if="!isNeedBack">
        <van-tabbar-item to="/home/uservipcenter" icon="user-o">个人中心</van-tabbar-item>
        <van-tabbar-item to="/home/rentnumber" icon="underway-o">养号</van-tabbar-item>
        <van-tabbar-item to="/home/xorder" icon="bill-o">下单</van-tabbar-item>
        <van-tabbar-item to="/home/orderm" icon="bag-o">订单</van-tabbar-item>
        <van-tabbar-item to="/home/shopm" icon="goods-collect-o">商店</van-tabbar-item>
        <!-- <van-tabbar-item >
          <template #icon="props">
            <van-button round type="primary"
                        style="width: 60px;height: 60px;position: fixed; left: 42%; bottom: 10px;justify-self: center"
                        text="接单"
                        @click="reciveOrder">
            </van-button>
          </template>
        </van-tabbar-item> -->
      </van-tabbar>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/Sidebar.vue'
import {getRole} from "../api/system/sys_user";
import {MessageBox} from "mint-ui";
import {queryCustomeSetting} from "../api/system/sys_plateform";

export default {
  name: 'Home',
  components:{
    Sidebar
  },
  data(){
    return {
      titles:"首页",
      isNeedBack: false,
      sidebarShow: false
    }
  },
  computed:{
    isNeedBackShow(){
      return this.isNeedBack;
    }
  },
  mounted() {
    if (this.titles == "首页" || this.titles == "会员中心" || this.titles == "养号" || this.titles == "下单"
      || this.titles == "订单" || this.titles == "商店"
    ){
      this.isNeedBack = false;
    }

    queryCustomeSetting().then(res=>{
      if (res.success){
        this.titles = res.data.customerWebTitle;
        this.tabbarbackgroundcolor = res.data.customerThemeStyle;
      }
    });
  },
  updated() {
    if (this.titles == "首页" || this.titles == "会员中心" || this.titles == "养号" || this.titles == "下单" 
      || this.titles == "订单" || this.titles == "商店"
    ){
      this.isNeedBack = false;
    }
  },
  methods:{
    backUp(){
      /*if (this.titles !== "首页"){
        this.$router.back(-1);
      }else{
        this.$router.push({path:"firstpage"});
      }
       */
      this.$router.back();
    },
    backMain(){
      this.$router.push({path:"/home/uservipcenter"})
    },
    handleClick(){
      this.sidebarShow = true;
    },
    // 接收 Sidebar组件的返回值 隐藏 侧滑菜单
    setSidebar(val){
      this.sidebarShow = val;
    },
    setTitleContent(title){
      this.titles = title;
      this.isNeedBack = true;
    },
    reciveOrder() {
      if (this.$route.path != '/home/userordercondition') {
        let that = this;
        getRole().then(res => {
          if (res.success) {
            if (res.data[0] == "anchor") {
              that.$router.push({path: '/home/taskbrocastlist'});
            } else {
              that.$router.push({path: '/home/userordercondition'});
            }
          }
        }).catch(err => {
          MessageBox({
            title: '提示',
            message: err.message,
            showCancelButton: true
          });
        });
      }else{
        this.$refs['OrderCondition'].orderClick();
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.tui{
  width: 100px;
  height: 100px;
  margin-top: -40px;
  z-index: 100000;
}
[class*=van-hairline]::after{
  border:none!important
}

/deep/.van-tabbar{
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: content-box;
  width: 100%;
  height: 50px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
